<div class="container_newsletter">
  <img src="./assets/img/banner_nesletter.webp" alt="bg newsletter" />
  <div class="dark_opacity"></div>
  <div class="form_newsletter">
    <h2 class="title_secctions">Newsletter</h2>

    @if (response.success) {
      <div [innerHTML]="response.message"></div>
    } @else {
      <p>Regístrese para el boletín y reciba todas las noticias y ofertas exclusivas!</p>
      <form [formGroup]="form" (ngSubmit)="submit(form)">
        <ul>
          <li>
            <input type="text" name="" id="" placeholder="Correo electronico" maxlength="50" formControlName="email" />
            @if (email?.invalid && email?.dirty) {
              @if (email?.errors?.["email"]) {
                <p>El mail es invalido</p>
              }
              @if (email?.errors?.["required"]) {
                <p>El mail es requerido</p>
              }
            }
          </li>
          <li>
            <button type="button" (click)="submit(form)">Inscribirse</button>
          </li>
        </ul>
      </form>
    }
  </div>
</div>
